import React from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

function AttachmentField({
  attachmentId,
  attachment, 
  isNew, 
  action, 
  onChange,
  onRemoveAttachment
}) {
  let attachmentName = '';
  let attachmentLink = '';
  if (typeof(attachment) !== "undefined" && Object.keys(attachment).length) {
    attachmentName = attachment.attachment_name;
    attachmentLink = attachment.attachment_link;
  }
  return (
    <Row className="mt-3" id={'attachment-id-' + attachmentId}>
      <Col xs={2} sm={2} md={2} lg={2} xl={2}>
        {action === 'UPDATE_PROJECT' && !isNew ? <Form.Control 
          id={attachmentId} 
          className="attachment_name" 
          size="sm" 
          value={attachmentName}
          placeholder="Attachment Name" 
          onChange={(e) => {
            onChange(e, attachmentId, 'attachment_name');
          }}
          type="text" /> : 
        <Form.Control 
          id={attachmentId} 
          className="attachment_name" 
          size="sm" 
          defaultValue={attachmentName}
          placeholder="Attachment Name" 
          onChange={(e) => {
            onChange(e, attachmentId, 'attachment_name');
          }}
          type="text" /> }
      </Col>
      <Col xs={3} sm={3} md={3} lg={3} xl={3}>
        {action === 'UPDATE_PROJECT' && !isNew ? <Form.Control 
          id={attachmentId} 
          className="attachment_link"  
          value={attachmentLink}
          size="sm" 
          onChange={(e) => {
            onChange(e, attachmentId, 'attachment_link');
          }}
          placeholder="Attachment Link" 
          type="text" /> :
        <Form.Control 
          id={attachmentId} 
          className="attachment_link"  
          defaultValue={attachmentLink}
          size="sm" 
          onChange={(e) => {
            onChange(e, attachmentId, 'attachment_link');
          }}
          placeholder="Attachment Link" 
          type="text" /> }
      </Col>
      <Col xs={1} sm={1} md={1} lg={1} xl={1}>
        <Button className="btn-icon" onClick={() => {
          onRemoveAttachment(attachmentId);
        }}>
          <FontAwesomeIcon icon={faTimes} />
        </Button>
      </Col>
    </Row>
  )
}

export default AttachmentField